const submitDaily = {
    data() {
        return {
            formSubmitStatus: {
                type: Boolean,
                default: false,
            },
            pageToRedirect: "",
        };
    },
    methods: {
        submitService() {
            const adminEdit = this.$storage.getStorageSync("adminEdit") || false;
            const service = this.$storage.getStorageSync("service") || {};
            const imgData = this.$storage.getStorageSync("imgData") || {};
            const ages = this.$storage.getStorageSync("ages") || [];
            const venueData = this.$storage.getStorageSync("venueData") || {};
            const venueMobile = this.$storage.getStorageSync("venueMobile") || {};
            const settings = this.$storage.getStorageSync("settings") || {};
            const checkedWeekday = this.$storage.getStorageSync("checkedWeekday") || [];
            const availability = this.$storage.getStorageSync("availability") || false;
            const prices = this.$storage.getStorageSync("prices") || [];
            const freeService = this.$storage.getStorageSync("freeService") || false;

            const data = {
                userId: window.currentUserId,
                adminEdit,
                imgData,
                service,
                ages,
                venueData,
                venueMobile,
                settings,
                checkedWeekday,
                availability,
                prices,
                freeService,
            };

            return $.ajax({
                url: "/register-service",
                method: "POST",
                data,
                dataType: "json",
            });
        },
    },

};

export default submitDaily;
